import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import New from '@/components/New'
import Main from '@/components/Main'
import MyLogs from '@/components/MyLogs'
import MyFavorites from '@/components/MyFavorites'
import Signup from '@/components/Signup'
import Signin from '@/components/Signin'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import TermsOfService from '@/components/TermsOfService'
import FileUpload from '@/components/FileUpload'
import AnalyzedResult from '@/components/AnalyzedResult'
import LogView from '@/components/LogView'
import store from "./store";

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/new',
      name: 'New',
      component: New,
      meta: { requiresAuth: true }
    },
    {
      path: '/upload',
      name: 'FileUpload',
      component: FileUpload,
      meta: { requiresAuth: true }
    },
    {
      path: '/analyzed/:fileid',
      name: 'AnalyzedResult',
      component: AnalyzedResult,
      meta: { requiresAuth: true }
    },
    {
      path: '/_log/:logid',
      name: 'LogView',
      component: LogView
    },
    {
      path: '/mylogs',
      name: 'MyLogs',
      component: MyLogs,
      meta: { requiresAuth: true }
    },
    {
      path: '/myfavorites',
      name: 'MyFavorites',
      component: MyFavorites,
      meta: { requiresAuth: true }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/terms',
      name: 'TermsOfService',
      component: TermsOfService
    }
  ]
})

router.beforeEach((to, from, next) => {
  /*
  store.commit('setMyCurrentPage', 1)
  store.commit('setMyLogs', [])
  store.commit('setCurrentPage', 1)
  store.commit('setLogs', [])
  */
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
      next()
    } else {
      store.commit('setUser', null)
      if (requiresAuth) {
        next('signin')
      } else {
        next()
      }
    }
  });
})

router.afterEach(() => {
  store.commit('setCurrentPage', 1)
  store.commit('setLogs', [])
  store.commit('setTotalRows', 0)
  store.commit('setPerPage', 20)
})
export default router
